export const additionalInstructionFieldsNames = ['title', 'text_for_non_registered', 'text_for_registered'] as const;

export type AdditionalInstructionFieldsNames = (typeof additionalInstructionFieldsNames)[number];
